import React from 'react';
import { useMustacheTranslation, useOTSTranslation, useSurfaceTypeTranslation } from 'i18n/useOTSTranslation';
import { formatPercentVal } from 'util/formatPercent';
import { IResortPageSnowInfo, IResortPathInfo } from 'api/resort/types';
import { MetricBox } from 'components/blocks/MetricBox';
import classNames from 'classnames';
import { useDistanceFormatter } from 'i18n/unitFormat';
import { SHORT_DATE_FORMAT, formatDateFromStr } from 'util/formatDate';
// import { NextLinkTr } from 'components/blocks/NextLink';
// import { Routes } from 'routes';
import styles from './styles.module.scss';

export const SnowDepth = ({ fullResort }: { fullResort: IResortPageSnowInfo, pathInfo: IResortPathInfo }) => {
  const { t } = useOTSTranslation('common');
  const m = useMustacheTranslation('common');
  const eS = useSurfaceTypeTranslation();
  const distanceFormatter = useDistanceFormatter('cmOrInchShort');
  const relativeToAvg = fullResort.depthAverages?.base ? 100 * (fullResort.snow.base / fullResort.depthAverages.base) : null;
  const showMid = fullResort.snow.middle && fullResort.snow.middle !== fullResort.snow.base;

  return (
    <div className={styles.innerLayout}>
      {!!fullResort.snow.base && (
      <div className={classNames(styles.innerLeft)}>
        <MetricBox title={t('common.base')}>
          <div className={classNames(styles.metricNumber)}>
            {distanceFormatter(fullResort.snow.base || 0, undefined, 'common.na')}
          </div>
          <div className={classNames(styles.metricCaption)}>
            {eS(fullResort.surfaceTypeBottom, 'resort.skiReport.surfaceNotAvailable')}
          </div>
        </MetricBox>
      </div>
      )}

      {!!showMid && (
      <div className={classNames(styles.innerLeft)}>
        <MetricBox
          title={t('common.mid')}
        >
          <div className={classNames(styles.metricNumber)}>
            {distanceFormatter(fullResort.snow.middle || 0, undefined, 'common.na')}
          </div>
          <div className={classNames(styles.metricCaption)}>
            {eS(fullResort.surfaceType, 'resort.skiReport.surfaceNotAvailable')}
          </div>
        </MetricBox>
      </div>
      )}

      {!!fullResort.snow.summit && (
        <div className={classNames(styles.innerLeft)}>
          <MetricBox
            title={t('common.summit')}
          >
            <div className={classNames(styles.metricNumber)}>
              {distanceFormatter(fullResort.snow.summit || 0, undefined, 'common.na')}
            </div>
            <div className={classNames(styles.metricCaption)}>
              {eS(fullResort.surfaceType, 'resort.skiReport.surfaceNotAvailable')}
            </div>
          </MetricBox>
        </div>
      )}

      {!!(relativeToAvg && fullResort.depthAverages?.base) && (
      <div className={classNames(styles.innerLeft)}>
        <MetricBox
          title={t('resort.skiReport.depthVsAverage')}
//           link={(
//             <NextLinkTr href={Routes.resortSnowfall(pathInfo)} data-click-id="resort-report-snowplanner">
//               {t('resort.skiReport.historicalSnowfall')}
//             </NextLinkTr>
// )}
        >
          <div className={classNames(styles.metricNumber)}>
            {formatPercentVal(relativeToAvg)}
          </div>
          <div className={classNames(styles.metricCaption)}>
            {m('resort.skiReport.depthVsAverageCaption', {
              avg: distanceFormatter(fullResort.depthAverages.base),
              date: formatDateFromStr(fullResort.updatedAt, SHORT_DATE_FORMAT),
            })}
          </div>
        </MetricBox>
      </div>
      )}
    </div>
  );
};
